var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"van-toast van-toast--text van-toast--middle",staticStyle:{"z-index":"2015"}},[_c('div',{staticStyle:{"line-height":"30px"}},[_vm._v(_vm._s(_vm.textOptions.message))])])}
var staticRenderFns = []

export { render, staticRenderFns }